import { AdjustmentsIcon, ShieldCheckIcon, UserIcon } from "@heroicons/react/outline"

import { ScreenPaths } from "../routing"
import type { NavigationLinkItem } from "./types/NavigationLinkItem"

type AccountLinks = "profile" | "security" | "preferences"

export const accountConfig: {
    [property in AccountLinks]: NavigationLinkItem
} = {
    profile: {
        label: "Profile",
        path: ScreenPaths.Account,
        displayType: "link",
        isDisabled: false,
        icon: UserIcon
    },
    security: {
        label: "Security",
        path: ScreenPaths.Security,
        displayType: "link",
        isDisabled: false,
        icon: ShieldCheckIcon
    },
    preferences: {
        label: "Preferences",
        path: ScreenPaths.Preferences,
        displayType: "link",
        isDisabled: false,
        icon: AdjustmentsIcon
    }
}

export const accountNavigationConfig: NavigationLinkItem[] = [
    accountConfig.profile,
    accountConfig.security,
    accountConfig.preferences
]
